var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/po-box.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n<div class=\"c-form__field\">\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"address")),"poBox") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"address")),"poBox") == true) {
output += "\n\n        <input type=\"checkbox\" name=\"address.poBox\" id=\"address.poBox\" class=\"c-form-adjacent__checkbox js-address-form-item\" checked aria-describedby=\"address.poBox_error\"/>\n\n    ";
;
}
else {
output += "\n\n        <input type=\"checkbox\" name=\"address.poBox\" id=\"address.poBox\" class=\"c-form-adjacent__checkbox js-address-form-item\" aria-describedby=\"address.poBox_error\"/>\n\n    ";
;
}
output += "\n\n    <label for=\"address.poBox\" id=\"address.poBox_error\" class=\"c-form-adjacent__label\">";
output += runtime.suppressValue((lineno = 13, colno = 89, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-poBox",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</label>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/po-box.j2"] , dependencies)